<script lang="ts">
	//Svelte
	import { onMount } from 'svelte';
	// Services
	import { format } from 'svelte-i18n';
	//Design System Components
	import { Text, Stack } from '@Shelly/shelly-design-system';
	//Helpers
	import { getAlarmGroupedDevices, getAllAlarmsGroupedDevices } from '../../list-helpers';
	// Types
	import type { IAlarmZone } from 'src/components/AlarmZones/AlarmWizard/alarm_object';
	//Components
	import AlarmListItemGroup from './AlarmListItemGroup.svelte';
	import AlarmSensorStateRow from './AlarmSensorStateRow.svelte';

	export let alarm: IAlarmZone;
	export let alarmsList: IAlarmZone[] = [];
	export let listenAlarmChange = false;
	export let showItemsActBtn = true;
	export let showItemsSubtitle = false;

	let alarmGroupedDevices = {
		offline: [],
		breached: [],
		checked: [],
		deletedDevice: [],
	};

	onMount(() => {
		if (alarmsList.length) {
			alarmGroupedDevices = getAllAlarmsGroupedDevices(alarmsList);
		} else {
			alarmGroupedDevices = getAlarmGroupedDevices(alarm);
		}
	});

	// Reactive update only when needed and expect alarm data change. To prevent func unnecessary executions.
	$: alarm && listenAlarmChange && alarmsList.length === 0
		? (alarmGroupedDevices = getAlarmGroupedDevices(alarm))
		: null;
</script>

<Text class="mb-s" styleType="h2">
	{$format('label_alarm_breached_sensor_state', {
		default: 'Sensors’ States',
	})}
</Text>

<Stack gap="s">
	<AlarmSensorStateRow
		icon="fas fa-warning"
		color="warning"
		counter={alarmGroupedDevices?.breached?.length}
		title={$format('label_alarm_breached', { default: 'Breached' })}
	/>

	<AlarmSensorStateRow
		icon="fas fa-cloud-slash"
		color="muted"
		counter={alarmGroupedDevices?.offline?.length}
		title={$format('label_alarm_offline', { default: 'Offline' })}
	/>

	<AlarmSensorStateRow
		icon="fas fa-check"
		color="success"
		counter={alarmGroupedDevices?.checked?.length}
		title={$format('label_alarm_checked', { default: 'In check' })}
	/>
</Stack>

{#if alarmGroupedDevices?.breached.length || alarmGroupedDevices?.offline.length || alarmGroupedDevices?.checked.length}
	<hr class="mb-l mt-l" />
{/if}

<Stack gap="xs">
	<AlarmListItemGroup
		{showItemsActBtn}
		{showItemsSubtitle}
		alarmDevicesGroup={alarmGroupedDevices?.breached}
		title={$format('label_alarm_breached_count', {
			default: 'Breached ({count})',
			values: { count: alarmGroupedDevices?.breached.length },
		})}
		groupExtraText={{
			title: $format('label_alarm_breached', {
				default: 'Breached',
			}),
			icon: 'fas fa-warning',
			color: 'white',
			iconColor: '--color-warning',
		}}
		on:deviceClick
	/>

	<AlarmListItemGroup
		{showItemsActBtn}
		{showItemsSubtitle}
		alarmDevicesGroup={alarmGroupedDevices?.offline}
		title={$format('label_alarm_offline_count', {
			default: 'Offline ({count})',
			values: { count: alarmGroupedDevices?.offline.length },
		})}
		groupExtraText={{
			title: $format('label_alarm_offline', {
				default: 'Offline',
			}),
			icon: 'fas fa-cloud-slash',
			color: 'white',
			iconColor: '--color-muted',
		}}
		on:deviceClick
	/>

	<AlarmListItemGroup
		{showItemsActBtn}
		{showItemsSubtitle}
		alarmDevicesGroup={alarmGroupedDevices?.checked}
		title={$format('label_alarm_checked_count', {
			default: 'In check ({count})',
			values: { count: alarmGroupedDevices?.checked.length },
		})}
		groupExtraText={{
			title: $format('label_alarm_checked', {
				default: 'In check',
			}),
			icon: 'fas fa-check',
			color: 'white',
			iconColor: '--color-success',
		}}
		on:deviceClick
	/>
</Stack>
